var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIokeeBlackLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iokee_rgb_energyblue 2",
    clipPath: "url(#clip0_454_1437)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.6188 18.6497H12.7607C11.8881 18.6497 11.0513 18.9963 10.4343 19.6133L0.0228577 30.0248L10.4343 40.4362C11.0513 41.0531 11.8881 41.3998 12.7607 41.3998H18.6188L7.24379 30.0248L18.6188 18.6497Z",
    fill: "#000030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M41.3966 18.6497H47.2548C48.1274 18.6497 48.9641 18.9963 49.5811 19.6133L59.9926 30.0248L49.5811 40.4362C48.9641 41.0531 48.1274 41.3998 47.2548 41.3998H41.3966L52.7716 30.0248L41.3966 18.6497Z",
    fill: "#000030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M41.3689 18.6497V12.7914C41.3689 11.9189 41.0223 11.0821 40.4053 10.4652L29.9939 0.0537109L19.5824 10.4652C18.9655 11.0821 18.6188 11.9189 18.6188 12.7914V18.6497L29.9939 7.27464L41.3689 18.6497Z",
    fill: "#000030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M18.6188 41.3999V47.258C18.6188 48.1306 18.9655 48.9674 19.5824 49.5844L29.9939 59.9958L40.4053 49.5844C41.0223 48.9674 41.3689 48.1306 41.3689 47.2581V41.3999L29.9939 52.7749L18.6188 41.3999Z",
    fill: "#000030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M24.2682 31.6173V42.7477L34.0434 32.9726C35.2156 31.8002 35.8741 30.2103 35.8741 28.5525V17.4219L26.0989 27.1972C24.9267 28.3694 24.2682 29.9593 24.2682 31.6173Z",
    fill: "#000030"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_454_1437"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIokeeBlackLogo);
export default __webpack_public_path__ + "static/media/iokee_black_logo.3735647f123d92bba3e09c1a1a6843f5.svg";
export { ForwardRef as ReactComponent };